$black: #111;
$black-200: #999;
$gray: rgba(0, 0, 0, 0.6);
$error: rgba(200, 2, 2, 0.623);
$light: #eee;
$light-200: #ddd;
$width: 700px;

body {
  margin: 0;
  padding: 0;
  font-family: sans-serif;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.id {
  display: none;
  font-size: 0.7rem;
  font-weight: 100;
}

.orgaheader {
  width: 700px;
  background-color: #ccc;
  padding: 4px;
  margin: 3px;
}
.orgaheader:hover {
  cursor: pointer;
}

.hidden {
  display: none;
}

svg > path {
  fill: none;
  stroke: #3a3;
}

.project-work {
  margin: 2px;
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.project-name {
  width: 330px;
  overflow: none;
}

.user-info,
.organization-info,
.uploadlog {
  margin-left: 50px;

  display: flex;
  flex-direction: column;
  font-size: 1.1rem;

  h2 {
    color: $gray;
    margin-bottom: 20px;
    text-align: center;
    width: $width;
  }

  label {
    margin-bottom: 30px;
    color: $gray;
  }

  .label {
    margin-bottom: 5px;
  }

  input {
    font-size: 1.2rem;
    width: $width;
    border: hidden;
    outline: none;
    border-bottom: 1px solid $gray;
  }
}

.output-text {
  width: $width;
  color: $black;
  min-height: 20px;
  border: 1px solid $gray;
  background-color: #eee;
}

.output-text--loading {
  width: $width;
  color: $gray;
  min-height: 20px;
}

.output-text--error {
  width: $width;
  color: $error;
  min-height: 20px;
}

.bottom-border {
  border-bottom: 1px solid $gray;
}

.button {
  margin-top: 30px;
  font-size: 16px;
  background-color: $light;
  width: 200px;
  height: 40px;
  outline: none;
  &:hover {
    background-color: $light-200;
    cursor: pointer;
  }
  &:disabled {
    background-color: $light;
    color: $black-200;
  }
}
